// extracted by mini-css-extract-plugin
export var adjacentSlide = "_jb-9";
export var arrowButtonContainer = "_jb-5";
export var arrowButtonIcon = "_jb-6";
export var carouselArrowButton = "_jb-2";
export var carouselElementContainer = "_jb-1";
export var currentSlide = "_jb-8";
export var left = "_jb-3";
export var otherSlide = "_jb-a";
export var productCarouselContainer = "_jb-0";
export var right = "_jb-4";
export var sliderOverflow = "_jb-7";